import React from 'react';
import style from './loadingIndicator.module.scss';
import classNames from 'classnames';

export enum LoadingIndicatorColour {
    White,
    Blue
}

interface LoadingIndicatorProps {
    colour?: LoadingIndicatorColour;
}

export class LoadingIndicator extends React.Component<LoadingIndicatorProps, {}> {
    render(): JSX.Element {
        const colour = this.props.colour || LoadingIndicatorColour.Blue;
        const colourClass = this.props.colour === LoadingIndicatorColour.White ? style.White : style.Blue;
        return (
            <div className={style.LoadingIndicator}>
                <div className={classNames(style.Inner, colourClass)}>
                    <div className={style.Bubble} />
                    <div className={style.Bubble} />
                    <div className={style.Bubble} />
                </div>
            </div>
        );
    }
}
